/**
 * Watch-limit pop-up (owner sign-off 2026-09-03, mockup artifact
 * 1180c1bb). Shown when the API refuses a watch create with
 * error code "watch_limit_reached" (20 active watches). One shared
 * dialog for EVERY watch-create surface - comparison watch button,
 * Ask panel, My searches - so the behaviour and look are identical
 * everywhere. Built on the same Radix + mio-dialog kit as the auth
 * dialog; theme-aware via the app tokens.
 */

"use client";

import * as Dialog from "@radix-ui/react-dialog";
import { useRouter } from "next/navigation";

type WatchLimitDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function WatchLimitDialog({ open, onOpenChange }: WatchLimitDialogProps) {
  const router = useRouter();

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="mio-dialog-overlay" />
        <Dialog.Content
          className="mio-dialog-content"
          aria-describedby="mio-watch-limit-description"
        >
          <div className="mio-dialog-col">
            <button
              type="button"
              className="mio-dialog-close"
              aria-label="Close"
              onClick={() => onOpenChange(false)}
            >
              <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                <path d="M2 2l10 10M12 2L2 12" />
              </svg>
            </button>

            <div className="mio-limit-card">
              <div className="mio-limit-glyph" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.7 21a2 2 0 0 1-3.4 0" />
                </svg>
              </div>
              <Dialog.Title className="mio-limit-title">
                You&rsquo;ve reached 20 watches
              </Dialog.Title>
              <Dialog.Description
                id="mio-watch-limit-description"
                className="mio-limit-body"
              >
                Your account can watch up to 20 products at a time. Just stop a
                watch you no longer need, then add this one.
              </Dialog.Description>
              <div className="mio-limit-actions">
                <button
                  type="button"
                  className="mio-limit-primary"
                  onClick={() => {
                    onOpenChange(false);
                    router.push("/watches");
                  }}
                >
                  Manage my watches
                </button>
                <button
                  type="button"
                  className="mio-limit-ghost"
                  onClick={() => onOpenChange(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
